import { render, staticRenderFns } from "./adminLayout.vue?vue&type=template&id=6468e516&scoped=true&"
import script from "./adminLayout.vue?vue&type=script&lang=js&"
export * from "./adminLayout.vue?vue&type=script&lang=js&"
import style0 from "./adminLayout.vue?vue&type=style&index=0&id=6468e516&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6468e516",
  null
  
)

export default component.exports